import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl } from 'react-intl'
import Tag from '@vtex/styleguide/lib/Tag'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import Link from '@/checkout-instore-legacy/components/Commons/Elements/Link'
import InsightsContainer from '@/checkout-instore-legacy/customer/containers/InsightsContainer'
import Loader from '@/checkout-instore-legacy/components/Commons/Loader'
import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'
import customerShape from '@/checkout-instore-legacy/customer/shapes'
import getClassStyle from '../../utils/getClassStyle'
import { filterCustomerClusters } from '../utils'

import LastVisited from './LastVisited'

class Profile extends PureComponent {
  constructor(props) {
    super(props)
    this.onBaseColor = getClassStyle('c-on-base', 'color')
  }

  componentDidMount() {
    if (!this.props.customer.profile) {
      this.props.refreshCustomer(this.props.intl)
    }
  }

  render() {
    const {
      customer: { profile, openCart },
    } = this.props
    const loading = !profile

    const customerClusters = filterCustomerClusters(
      profile && profile.customerClusters && profile.customerClusters.data
    )

    return (
      <div className="h-100">
        {loading ? (
          <Loader loading />
        ) : (
          <div
            className="flex flex-column h-100 bg-muted-5 overflow-auto ph5 ph8-l pv6 pv8-l momentum c-on-base"
            id="customer-profile"
          >
            <div className="w-100 h-100 mw8 center-all">
              <div className="pb5 b--muted-3 bb">
                <div className="f2 fw7 f1-ns">
                  {profile.fullName && profile.fullName.data}
                </div>

                {customerClusters && customerClusters.length > 0 && (
                  <div className="mv2">
                    {customerClusters.map((cluster, index) => {
                      return (
                        <Tag
                          bgColor={this.onBaseColor}
                          key={cluster.id || index}
                        >
                          {cluster.label}
                        </Tag>
                      )
                    })}
                  </div>
                )}

                {openCart && openCart.customerIdentification !== null && (
                  <Link
                    className="mr6 f7"
                    intlId="openCartAction"
                    to={`cart-change/${openCart.orderFormId}/${openCart.code}`}
                  />
                )}
                <Link className="f7" intlId="changeIdentifiedClient" to="/" />
              </div>

              {profile.lastSessionDate && (
                <div className="mt4">
                  <LastVisited lastSessionDate={profile.lastSessionDate} />
                </div>
              )}
              <div className="mt7 mt8-l">
                <InsightsContainer />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

Profile.propTypes = {
  customer: customerShape,
  refreshCustomer: PropTypes.func,
  intl: intlShape.isRequired,
  cartStatus: PropTypes.shape({
    error: PropTypes.bool,
    errorMessage: PropTypes.string,
  }),
}

export default injectIntl(withRouter(withOrderFormAndVendor(Profile)))
